require("./src/pages/global.css");